import Price from './price';
import Deal from './deal';
import Service from './service';
import Commission from './commission';
import { PriceHistory, PriceHistoryItem } from './priceHistory';

const Finance = {
  Service,
  Price,
  Commission,
  PriceHistoryItem,
  PriceHistory,
  Deal
};

module.exports = Finance;



// WEBPACK FOOTER //
// ./src/classes/finance/index.js